/**
 * @module gameActions
 * @description SignalR game actions (score retrieval, word submission) and
 * blank-tile letter assignment for the Game component.
 */

import { extractBoardTiles } from "./boardUtils";

/**
 * @typedef {object} GetScoreDeps
 * @property {object} game - Current game state.
 * @property {object} connection - SignalR HubConnection instance.
 */

/**
 * Extracts newly placed tiles from the board and invokes the SignalR
 * "GetScore" hub method if the connection is active.
 * @param {GetScoreDeps} deps
 * @returns {void}
 */
export function getScore(deps) {
    const { game, connection } = deps;
    console.log("Getting Score", game);
    const boardTiles = extractBoardTiles(game.board);
    console.log("**** boardTiles sent to GetScore", JSON.stringify(boardTiles, null, 2));
    console.log("Scoring", game.id, game.playerIndex, boardTiles);
    if (connection && connection.state === "Connected") {
        console.log("Connection connected, getting score");
        connection.invoke("GetScore", game.id, game.playerIndex, boardTiles);
        console.log("GetScore invoked");
    }
}

/**
 * @typedef {object} PlayWordDeps
 * @property {object} game - Current game state.
 * @property {object} connection - SignalR HubConnection instance.
 */

/**
 * Extracts newly placed tiles from the board and invokes the SignalR
 * "PlayWord" hub method if the connection is active.
 * @param {PlayWordDeps} deps
 * @returns {void}
 */
export function playWord(deps) {
    const { game, connection } = deps;
    console.log("Play Word", game);
    const boardTiles = extractBoardTiles(game.board);
    console.log("Playing Word", game.id, game.playerIndex, boardTiles);
    if (connection && connection.state === "Connected") {
        console.log("Connection connected, getting score");
        connection.invoke("PlayWord", parseInt(game.id), parseInt(game.playerIndex), boardTiles);
        console.log("PlayWord invoked");
    }
}

/**
 * @typedef {object} ChooseForBlankDeps
 * @property {object} spaceWithBlank - The board space whose tile is a blank.
 * @property {object} game - Current game state.
 * @property {Array} rackTiles - Current rack tile array.
 * @property {function(object): void} setGame - Game state setter.
 * @property {function(boolean): void} setShowBlankSelector - Hides the blank-letter selector.
 */

/**
 * Assigns the chosen letter to the blank tile on the board, then closes
 * the blank-letter selector.
 * @param {string} letter - The letter chosen for the blank tile.
 * @param {ChooseForBlankDeps} deps
 * @returns {void}
 */
export function chooseForBlank(letter, deps) {
    const { spaceWithBlank, game, rackTiles, setGame, setShowBlankSelector } = deps;
    console.log("SELECTING", letter);
    spaceWithBlank.tile.tile.letter = letter;
    setGame({ ...game, rack: rackTiles });
    setShowBlankSelector(false);
}
